import React, { useState, useEffect } from 'react';
import { useKeenSlider } from 'keen-slider/react';

import 'keen-slider/keen-slider.min.css';
import './Gallery.css';

export default function Gallery(props) {
	const { images } = props;

	const ResizePlugin = (slider) => {
		const observer = new ResizeObserver(function () {
			slider.update()
		});
		slider.on("created", () => {
			observer.observe(slider.container)
		});
		slider.on("destroyed", () => {
			observer.unobserve(slider.container)
		});
	}

	const [loaded, setLoaded] = useState(false);
	const [currentSlide, setCurrentSlide] = useState(0);
	const [loadedSlides, setLoadedSlides] = useState([]);
	const [sliderRef, instanceRef] = new useKeenSlider({
		initial: 0,
		slideChanged(slider) { setCurrentSlide(slider.track.details.rel) },
		animationEnded(slider) { setCurrentSlide(slider.track.details.rel) },
		created() { setLoaded(true) }
	}, [ResizePlugin]);

	// create a slider arrow
	const Arrow = (props) => {
		const disabled = props.disabled ? " arrow--disabled" : ""
		return (<div className={`arrow--wrapper ${props.left ? "arrow--left" : "arrow--right"}`}>
			<svg
				onClick={props.onClick}
				className={`arrow${disabled}`}
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24"
			>
				{props.left && (<path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z" />)}
				{!props.left && (<path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z" />)}
			</svg>
		</div>)
	}
	
	// gallery html content
	const generateContent = (images) => {
		if (images !== null && images.length > 0) {
			return <div className="gallery">
				<div className="navigation-wrapper">
					<div ref={sliderRef} className="keen-slider">
						{[...images].map((image, index) => {
							let img = loadedSlides[index] ? image : "";
							return (
								<div key={index} className="keen-slider__slide lazy__slide image-slide">
									<div className="background-blur" style={{backgroundImage: `url(${img})`}}></div>
									<div className="overlay"></div>
									<img alt=" " src={img} />
								</div>
							)
						})}
					</div>
					{loaded && instanceRef.current && images.length > 1 &&
						<>
							<Arrow
								left
								onClick={(e) => e.stopPropagation() || instanceRef.current?.prev()}
								disabled={currentSlide === 0}
							/>
							<Arrow
								onClick={(e) => e.stopPropagation() || instanceRef.current?.next()}
								disabled={currentSlide === images.length - 1}
							/>
						</>
					}
				</div>
				{loaded && instanceRef.current && images.length > 1 &&
					<div className="dots">
					{[...Array(images.length).keys(),].map((idx) => {
						return (
							<button
								key={idx}
								onClick={() => {instanceRef.current?.moveToIdx(idx)}}
								className={"dot" + (currentSlide === idx ? " active" : "")}
							></button>
						)
					})}
					</div>
				}
			</div>
		} else {
			return 'Loading'
		}
	}

	// Reset gallery options on change of images
	useEffect(() => {
		//  update slider ref
		if (loaded && instanceRef?.current) instanceRef.current.update();
		// go to first slide
		if (instanceRef.current) instanceRef.current.moveToIdx(0);
		setCurrentSlide(0);
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [images]);

	// Load new slides to the gallery
	useEffect(() => {
		const newLoaded = [...loadedSlides];
		newLoaded[currentSlide] = true;
		setLoadedSlides(newLoaded);
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [currentSlide]);

	return generateContent(images);
}
